import { render } from "./search_and_filters.vue?vue&type=template&id=6d874b1a"
import script from "./search_and_filters.vue?vue&type=script&lang=ts"
export * from "./search_and_filters.vue?vue&type=script&lang=ts"
script.render = render

export default script